<template>
    <div class="py-3">
        <div class="container">
            <TravelExpenseReportTabs :linksDisabled=false :expenseReportID=existingExpenseReportID ref="nav"></TravelExpenseReportTabs>
            <div class="row">
                <div class="col-md-12">
                    <div v-if="!loading && existingExpenseReport.expenseReportStatusTypeId > 1" style="text-align:center; color:red;">Changes will not be saved unless Save button is clicked</div>
                    <h4 style="font-weight:900; margin-bottom:0px;">Rental Car <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner></h4>
                    <div class="my-1" style="margin-top:0px;">{{existingExpenseReport.expenseReportStatusTypeName}}</div>
                    <ValidationAlertComponent v-if="!loading" :expenseReportID="existingExpenseReportID" :area="'rental'" :key="validationKey"></ValidationAlertComponent>
                    <div v-if="!loading">
                        <h4 class="text-center">Note - Luxury vehicles are not allowed&nbsp;<span class="badge badge-pill badge-warning">!</span></h4>
                        <div v-for="(r,rIndex) in existingRental.rentalCars">
                            <form class="" v-on:submit.prevent>
                                <label>
                                    Rental Car {{rIndex + 1}} <button type="button" class="close" aria-label="Close" @click="showRemovalModal(ItemRemoveType.Rental,rIndex,null)">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </label>

                                <b-form-group label="Rental Company">
                                    <b-form-select v-model="r.rentalCompanyId" class="w-50" :options="rentalCompaniesTypes" value-field="id" text-field="displayName">
                                        <option :value="null" disabled>Choose an option</option>
                                    </b-form-select>
                                    <b-form-input v-if="r.rentalCompanyId == 5"
                                                  id="otherrentalcompany"
                                                  class="w-50 mt-1"
                                                  v-bind:class="{'is-invalid': !r.rentalCompanyOther }"
                                                  placeholder="Rental Company"
                                                  v-model="r.rentalCompanyOther">
                                    </b-form-input>
                                </b-form-group>

                                <div class="form-group">
                                    <label>Reimbursement Amount</label>
                                    <div v-if="tripHasPersonalDay && existingRental.rentalCars.length > 0">Because you indicated this trip has a personal component, please include only business-related expenses.</div>
                                    <div class="input-group w-25">
                                        <input v-model="r.amount" type="number" @focus="$event.target.select()" class="form-control" placeholder="Reimbursement Amount">
                                        <div class="input-group-append"><button class="btn btn-secondary" @click="$bvModal.show('rentalAttachments'+ rIndex)" type="button">Attach</button></div>
                                    </div>
                                    <span style="cursor: pointer">
                                        <div v-for="(aa,aaIndex) in r.amountAttachments">
                                            <span @click="downloadFileInNewWindow(aa)">{{aa.attachmentName}}</span> <span aria-hidden="true" @click="showRemovalModal(ItemRemoveType.RentalCarAttachment,rIndex,aaIndex)">&times;</span>
                                        </div>
                                    </span>
                                </div>
                                <!-- modal -->
                                <b-modal :id="'rentalAttachments' + rIndex" centered title="Add Receipt" :hide-footer=true>
                                    <AttachmentComponent :expenseReportId="existingExpenseReportID" :attachments="r.amountAttachments" @fileUploadDone="$bvModal.hide('rentalAttachments'+ rIndex)"></AttachmentComponent>
                                </b-modal>
                            </form>
                            <div v-if="tripHasPersonalDay && existingRental.rentalCars.length > 0">
                                <b-form-group label="Are you claiming an amount less than the amount paid?">
                                    <b-form-select v-model="r.amountClaimedLessThanPaidReasonId" class="w-50" :options="amountClaimedLessThanPaidReasons" value-field="id" text-field="displayName">
                                        <option :value="null" disabled>Choose an option</option>
                                    </b-form-select>

                                    <b-form-textarea :id="personalComment + rIndex"
                                                     class="my-1"
                                                     v-if="r.amountClaimedLessThanPaidReasonId == 2"
                                                     v-model="r.personalDayExplanation"
                                                     v-bind:class="{'is-invalid': !r.personalDayExplanation }"
                                                     placeholder="Personal component comment"
                                                     rows="1"
                                                     max-rows="3">
                                    </b-form-textarea>
                                </b-form-group>
                            </div>
                            <b-form-group label="Are you requesting reimbursement for an amount greater than the cost of compact class?">
                                <b-form-radio-group v-model="r.isMoreThanCompactClass"
                                                    :options="[{ text: 'Yes', value:true },{ text: 'No', value:false }]"></b-form-radio-group>
                            </b-form-group>

                            <b-form-group v-if="r.isMoreThanCompactClass" label="Please select applicable exception">
                                <b-form-select v-model="r.moreThanCompactClassTypeId" class="w-50" :options="moreThanCompactClassTypes" value-field="id" text-field="displayName">
                                    <option :value="null" disabled>Choose an option</option>
                                </b-form-select>
                                <b-form-textarea v-if="r.moreThanCompactClassTypeId == 4"
                                                 id="reason"
                                                 class="my-1"
                                                 v-bind:class="{'is-invalid': !r.rentalCostExceededExplanation }"
                                                 v-model="r.rentalCostExceededExplanation"
                                                 placeholder="Please Explain"
                                                 rows="3"
                                                 max-rows="6">
                                </b-form-textarea>
                            </b-form-group>

                            <b-form-group>
                                <label>Are you requesting reimbursement for insurance? <font-awesome-icon style="margin-left:5px;" :html="true" v-b-popover.hover="'Insurance coverage is typically not reimbursable given that PSI maintains a separate insurance policy for this purpose. PSI employees traveling on PSI business are covered by  Hired Auto Liability and Physical Damage insurance. An identification card for this benefit is available on the internal PSI website within the Travel section and you may also request a laminated copy from the Office Manager. Auto Liability Excess for domestic travel is provided by PSI with limits of $1,000,000 for bodily injury and/or property damage for each accident and $10,000 medical payments for each accident. Foreign countries require varying minimum insurance limits. In the event PSIs insurance policy does not meet the minimum criteria/limits for that country, insurance coverage would be allowable for reimbursement. Auto Liability Excess for international travel is provided by PSI with limits of $1,000,000 for bodily injury and/or property damage for each accident.'" icon="info-circle" /></label>
                                <b-form-radio-group @change="clearAdditionalAmmount(r)" v-model="r.isInsuranceExceedsPolicyLimits"
                                                    :options="[{ text: 'Yes', value:true },{ text: 'No', value:false }]"></b-form-radio-group>
                            </b-form-group>

                            <b-form-textarea v-if="r.isInsuranceExceedsPolicyLimits"
                                             id="InsuranceExceedsPolicyLimitsComment"
                                             class="w-50"
                                             v-model="r.reimbursementInsuranceExplanation"
                                             placeholder="Reimbursement insurance explanation"
                                             rows="1"
                                             max-rows="3"
                                             style="margin-bottom:15px;">
                            </b-form-textarea>

                            <div v-if="r.isInsuranceExceedsPolicyLimits">
                                <div class="form-group">
                                    <label>Cost</label>
                                    <div class="input-group w-25">
                                        <input v-model="r.additionalAmount" type="number" @focus="$event.target.select()" class="form-control w-25" placeholder="cost">
                                        <div class="input-group-append"> <button class="btn btn-secondary" @click="$bvModal.show('rentalAdditionalCostAttachment'+ rIndex)">Attach</button></div>
                                    </div>
                                </div>
                                <!--<p> Attach documentation of coverage requirement that exceeds PSI's policy limits. </p>-->
                                <span style="cursor: pointer">
                                    <div v-for="(aa,aaIndex) in r.additionalAmountAttachments">
                                        <span @click="downloadFileInNewWindow(aa)">{{aa.attachmentName}}</span> <span aria-hidden="true" @click="showRemovalModal(ItemRemoveType.RentalAdditionalAmount,rIndex,aaIndex)">&times;</span>
                                    </div>
                                </span>
                            </div>

                            <!-- modal -->
                            <b-modal :id="'rentalAdditionalCostAttachment' + rIndex" centered title="Add Receipt" :hide-footer=true>
                                <AttachmentComponent :expenseReportId="existingExpenseReportID" :attachments="r.additionalAmountAttachments" @fileUploadDone="$bvModal.hide('rentalAdditionalCostAttachment'+ rIndex)"></AttachmentComponent>
                            </b-modal>



                        </div>
                        <div class="form-group">
                            <button class="btn btn-secondary btn-sm mt-2" @click="addRentalCar()">Add Rental Car</button>
                        </div>

                        <div class="form-group" v-for="(fc, fcIndex) in existingRental.fuelCosts">
                            <label>
                                Fuel Cost {{fcIndex + 1}} (If not included elsewhere) <button type="button" class="close" aria-label="Close" @click="showRemovalModal(ItemRemoveType.FuelCost,fcIndex,null)">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </label>
                            <div class="input-group w-25">
                                <input v-model="fc.amount" type="number" @focus="$event.target.select()" class="form-control" placeholder="fuel cost">
                                <div class="input-group-append" v-if="fc.amount > 75"><button class="btn btn-secondary" @click="$bvModal.show('fuelAttachments'+ fcIndex)" type="button">Attach</button></div>
                            </div>
                            <span style="cursor: pointer">
                                <div v-for="(fca, fcaIndex) in fc.amountAttachments">
                                    <span @click="downloadFileInNewWindow(fca)">{{fca.attachmentName}}</span> <span aria-hidden="true" @click="showRemovalModal(ItemRemoveType.FuelCostAttachment,fcIndex,fcaIndex)">&times;</span>
                                </div>
                            </span>

                            <!-- modal -->
                            <b-modal :id="'fuelAttachments' + fcIndex" centered title="Add Receipt" :hide-footer=true>
                                <AttachmentComponent :expenseReportId="existingExpenseReportID" :attachments="fc.amountAttachments" @fileUploadDone="$bvModal.hide('fuelAttachments'+ fcIndex)"></AttachmentComponent>
                            </b-modal>
                        </div>

                        <div class="form-group">
                            <button class="btn btn-secondary btn-sm mt-2" @click="addFuelCost()">Add Fuel Cost </button>
                            <font-awesome-icon style="margin-left:5px;" v-b-popover.hover="'Only applicable when not included within rental car cost above.'" icon="info-circle" />
                        </div>

                        <!--<div v-if="tripHasPersonalDay && existingRental.rentalCars.length > 0">Because you indicated this trip has a personal component, please include only business-related expenses. Explain method used in supporting remarks section.</div>-->


                        <b-form-textarea id="supportingRemark"
                                         v-model="existingRental.supportingRemark"
                                         placeholder="Supporting remarks, if needed"
                                         rows="1"
                                         max-rows="3"
                                         style="margin-bottom:15px;">
                        </b-form-textarea>

                        <button type="button" class="btn btn-primary btn-lg" @click="saveRentalSection">Save</button>
                    </div>
                </div>
                <CommentsComponent v-if="!loading && existingExpenseReport.expenseReportStatusTypeId > 1" :expenseReportID="existingExpenseReportID" :area="'rental'"></CommentsComponent>
                <div v-if="!loading && existingExpenseReport.expenseReportStatusTypeId > 1" class="col-md-12">
                    <!-- audit history comp -->
                    <AuditHistoryComponent :expenseReportID="existingExpenseReportID" :area="'rental'"></AuditHistoryComponent>
                </div>
            </div>
        </div>
    <modal title="Confirm Delete?" :is-small="true" v-if="show_modal_remove" @close="show_modal = false">
        <div class="modal-body">
            Are you sure you want to remove this item?
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="removeItem(itemTypeToRemove, itemToRemove, attachmentToRemove)">Delete</button>
            <button type="button" class="btn btn-primary" @click="show_modal_remove = false">Cancel</button>
        </div>
    </modal>
    <modal title="Save progress?" :is-small="true" v-if="show_modal" @close="show_modal=false">
        <div class="modal-body">
            Save changes to expense report?
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="saveAndContinue(true)">Save</button>
            <button type="button" class="btn btn-primary" @click="saveAndContinue(false)">Cancel</button>
        </div>
    </modal>
    </div>
</template>


<script>
    // @ is an alias to /src
    import TravelExpenseReportTabs from '@/components/TravelExpenseReportTabs.vue'
    import AttachmentComponent from '@/components/AttachmentComponent.vue'
    import AuditHistoryComponent from '@/components/AuditHistoryComponent.vue'
    import CommentsComponent from '@/components/CommentsComponent.vue'
    import ValidationAlertComponent from '@/components/ValidationAlertComponent.vue'
    import modal from '@/components/modal.vue'

    export default {
        name: 'rental-car',
        components: {
            TravelExpenseReportTabs,
            AttachmentComponent,
            AuditHistoryComponent,
            CommentsComponent,
            ValidationAlertComponent,
            modal
        },
        created() {
            if (this.$route.params.erid) {
                this.existingExpenseReportID = this.$route.params.erid;
                //get types
                this.getRentalCarCompanyTypes();
                this.getMoreThanCompactClassTypes();
                this.getExistingRentalDetails(this.existingExpenseReportID);
                this.getExpenseReport();
                this.getAmountClaimedLessThanPaidReasons();
            }
        },
        data: function () {
            return {
                validationKey: 0,
                existingExpenseReportID: null,
                existingExpenseReport: null,
                existingRental: {
                    rentalCars: [],
                    existingRental: []
                },
                rentalCompaniesTypes: [],
                tripHasPersonalDay: false,
                moreThanCompactClassTypes: [],
                amountClaimedLessThanPaidReasons: [],
                loading: true,
                show_modal: false,
                navNext: null,
                show_modal_remove: false,
                itemToRemove: null,
                attachmentToRemove: null,
                itemTypeToRemove: null,
                ItemRemoveType: {
                    Rental: 0,
                    RentalCarAttachment: 1,
                    RentalAdditionalAmount: 2,
                    FuelCost: 3,
                    FuelCostAttachment: 4,

                }
            }
        },
        computed: {
            hashData: function () {
                return JSON.stringify(this.existingRental);
            }
        },
        methods: {
            removeItem(itemType, index, attachIndex) {
                switch (itemType) {
                    case 0:
                        this.removeRental(index);
                        break;
                    case 1:
                        this.removeRentalCarAttachment(index, attachIndex);
                        break;
                    case 2:
                        this.removeAdditionalAmountAttachment(index, attachIndex);
                        break;
                    case 3:
                        this.removeFuelCost(index);
                        break;
                    case 4:
                        this.removeFuelCostAttachment(index, attachIndex);
                        break;
                    default:
                        break;
                }
                this.show_modal_remove = false;
            },
            showRemovalModal(itemType, index, attachIndex) {
                this.itemToRemove = index;
                this.itemTypeToRemove = itemType;
                this.attachmentToRemove = attachIndex;
                this.show_modal_remove = true;
            },
            downloadFileInNewWindow(params) {
                console.log(params)
                let documentType = 'receipts/';
                if (params.attachmentTypeId == 2) {
                    documentType = 'InstitutionalDocuments/'
                }
                this.$http
                    .get(documentType + params.attachmentId + '/Download', {
                        responseType: 'blob',
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then((response) => {
                        const file = new Blob(
                            [response.data],
                            { type: response.headers['content-type'] });
                        const downloadUrl = window.URL.createObjectURL(file);
                        window.open(downloadUrl);
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => this.loading = false)
            },
            clearAdditionalAmmount(rental) {
                if (rental.isInsuranceExceedsPolicyLimits == false) {
                    rental.additionalAmount = 0;
                }
            },
            removeRentalCarAttachment(rIndex, aaIndex) {
                this.existingRental.rentalCars[rIndex].amountAttachments.splice(aaIndex, 1);
            },
            removeAdditionalAmountAttachment(rIndex, aaIndex) {
                this.existingRental.rentalCars[rIndex].additionalAmountAttachments.splice(aaIndex, 1);
            },
            removeFuelCostAttachment(fcIndex, fcaIndex) {
                this.existingRental.fuelCosts[fcIndex].amountAttachments.splice(fcaIndex, 1);
            },
            removeFuelCost(fcIndex) {
                this.existingRental.fuelCosts.splice(fcIndex, 1);
            },

            isValid() {
                //TODO: validation
                return true;
            },
            addFuelCost() {
                this.existingRental.fuelCosts.push({
                    amount: null,
                    amountAttachments: [],
                })
            },
            getExpenseReport() {
                this.$http
                    .get(`expensereports/${this.existingExpenseReportID}`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.existingExpenseReport = response.data;
                        this.existingExpenseReport.trip.destinations.forEach((d) => { if (d.personal == true) { this.tripHasPersonalDay = true; } })
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            },
            async saveAndContinue(save) {
                let success = false;
                if (save) {
                    success = await this.saveRentalSection();
                    if (success) {
                        this.navNext()
                    } else {
                        this.navNext()
                    }
                }
                else {
                    this.navNext()
                }
            },
            async saveRentalSection() {
                let isSuccess = false;
                if (this.isValid()) {
                    this.existingRental.rentalCars.forEach((rental) => { if (rental.isInsuranceExceedsPolicyLimits === null || (rental.isInsuranceExceedsPolicyLimits !== null && rental.isInsuranceExceedsPolicyLimits == false)) { rental.additionalAmount = 0; } })

                    await this.$http
                        .post('CarRentals/', this.existingRental, {
                            headers: {
                                "Authorization": "Bearer " + this.msal.accessToken
                            }
                        })
                        .then(response => {

                            this.$notify({
                                group: 'success',
                                type: 'success ',
                                title: 'Success',
                                text: "Rental saved successfully"
                            });
                            this.$refs.nav.getSummaryCosts();
                            isSuccess = true;
                            this.validationKey += 1;
                            window.scrollTo(0, 0);
                        })
                        .catch(error => {
                            let guiError = error;

                            if (error.response.data) {
                                guiError = error.response.data.join("<br>")
                            }

                            this.$notify({
                                group: 'errors',
                                type: 'error',
                                title: 'Error',
                                text: guiError
                            });
                            this.errored = true
                        })
                }
                return isSuccess;
            },
            addRentalCar() {
                this.existingRental.rentalCars.push({
                    rentalCompanyId: null,
                    amount: null,
                    isMoreThanCompactClass: null,
                    moreThanCompactClassTypeId: null,
                    isInsuranceExceedsPolicyLimits: null,
                    reimbursementInsuranceExplanation: null,
                    additionalAmount: 0,
                    amountAttachments: [],
                    additionalAmountAttachments: []
                })
            },
            removeRental(rentalIndex) {
                this.existingRental.rentalCars.splice(rentalIndex, 1);
            },
            getRentalCarCompanyTypes() {
                this.$http
                    .get('CarRentals/RentalCompanies', {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.rentalCompaniesTypes = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            },
            getMoreThanCompactClassTypes() {
                this.$http
                    .get('CarRentals/MoreThanCompactClassTypes', {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.moreThanCompactClassTypes = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            },
            getAmountClaimedLessThanPaidReasons() {
                this.$http
                    .get('CarRentals/AmountClaimedLessThanPaidReasons', {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.amountClaimedLessThanPaidReasons = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            },
            getExistingRentalDetails(erID) {
                this.$http
                    .get(`expensereports/${erID}/CarRental`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        //response.data.airfareTickets = _.orderBy(response.data.airfareTickets, "id")
                        //response.data.airfareBaggages = _.orderBy(response.data.airfareBaggages, "id")
                        this.existingRental = response.data;
                        this.hash = this.hashData;
                        //this.addDefaultBaggageFeeObjectIfDoesNotExist();
                        //this.addDefaultTicketObjectIfDoesNotExist();
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
                    .finally(() => this.loading = false
                    )
            },
        },

        async beforeRouteLeave(to, from, next) {
            if (this.existingExpenseReport.expenseReportStatusTypeId > 1) {
                next()
            }
            else {
                this.navNext = next;

                const dataToCompare = this.hashData;

                if (dataToCompare === this.hash) {
                    console.log("No changes");
                    next();
                }
                else {
                    console.log("Data changed");
                    this.show_modal = true;
                }
            }
        }
    }
</script>